import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Button, HelpText, useToasts, FileUpload, createForm } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';
import { MagicWandFillIcon } from '@applyboard/ui-icons';
import { useExtractPassportInfo } from "../../../data";
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form;
export function PassportAutoFill(_ref) {
  var onUploadPassportSuccessful = _ref.onUploadPassportSuccessful;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAutofillUpload = _useState2[0],
    setShowAutofillUpload = _useState2[1];
  var _useExtractPassportIn = useExtractPassportInfo(),
    extractPassportInfo = _useExtractPassportIn.extractPassportInfo;
  var toasts = useToasts();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var uploadFileCallback = function uploadFileCallback(file, params) {
    extractPassportInfo({
      file: file
    }, {
      onSuccess: function onSuccess(response) {
        if (response && Object.keys(response).length) {
          onUploadPassportSuccessful({
            firstName: response.name,
            lastName: response.surname,
            birthDate: response.birth_date,
            gender: response.sex && response.sex.toLowerCase() == 'm' ? 'male' : 'female',
            countryOfCitizenship: response.nationality && response.nationality.substr(0, 2).toUpperCase(),
            passportNumber: response.document_number,
            passportFile: file,
            passportExpiry: response.expiry_date
          });
          toasts.positive('File successfully scanned. Appropriate fields autofilled.');
          trackEvent({
            data: {
              firstName: !!response.name,
              lastName: !!response.surname,
              birthDate: !!response.birth_date,
              gender: !!response.sex,
              countryOfCitizenship: !!response.nationality,
              passportNumber: !!response.document_number,
              passportExpiry: !!response.expiry_date
            },
            event: 'Passport OCR - Upload Successful',
            group: 'Student Intake Form'
          });
        } else {
          toasts.warning('No passport information found. Please make sure photo is clearly framed and in focus.');
        }
        params.onSuccess(response.document_number || '');
      },
      onError: function onError() {
        params.onError("The uploaded file may not contain any relevant information. Please make sure it\u2019s the right document and try again or fill out the form manually instead.");
        trackEvent({
          event: 'Passport OCR - Upload Unsuccessful',
          group: 'Student Intake Form'
        });
      }
    });
  };
  return showAutofillUpload ? /*#__PURE__*/React.createElement(Form, {
    defaultValues: {},
    onSubmit: function onSubmit() {}
  }, /*#__PURE__*/React.createElement(Field, {
    as: FileUpload,
    allowedFileTypes: ['.jpg', '.jpeg', '.png', '.pdf'],
    helpText: "Accepted file formats: PNG, PDF, JPG, and JPEG. Maximum file size 10MB.",
    label: "Autofill with passport",
    name: "passportFile",
    maxFileSize: 10000000 // 10 MB
    ,
    size: "sm",
    uploadFile: uploadFileCallback
  }, /*#__PURE__*/React.createElement(FileUpload.Button, null, "Files"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      setShowAutofillUpload(true);
    },
    leadIcon: MagicWandFillIcon,
    intent: "primary",
    emphasis: "highlighted"
  }, "Autofill with passport"), /*#__PURE__*/React.createElement(HelpText, null, "Auto-complete this section by uploading your passport. This is optional, but strongly recommended."));
}